import { useEffect, useMemo, useState } from "react";

/**
 * Lightweight IntersectionObserver hook (no deps).
 * Returns a callback ref + boolean for "in view" (once by default).
 */
export function useInView(options = {}) {
  const { root = null, rootMargin = "0px", threshold = 0.2, once = true } = options;
  const [node, setNode] = useState(null);
  const [inView, setInView] = useState(false);

  const observerOptions = useMemo(
    () => ({ root, rootMargin, threshold }),
    [root, rootMargin, threshold]
  );

  useEffect(() => {
    if (!node) return;
    if (inView && once) return;

    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        if (once) obs.disconnect();
      } else if (!once) {
        setInView(false);
      }
    }, observerOptions);

    obs.observe(node);
    return () => obs.disconnect();
  }, [node, observerOptions, once, inView]);

  return { ref: setNode, inView };
}

